import LAYOUT from '@/layout/layout';
import TechnicalDiagnosticsLayout from '@/modules/TechnicalDiagnostics/layout/Layout.vue';
import TechnicalDiagnosticsSettings from '@/modules/TechnicalDiagnostics/views/TechnicalDiagnosticsSettings.vue';
import settingsLayout from '@/views/Settings/SettingsPage.vue';

export default [
  {
    path: '/technical-diagnostics',
    component: LAYOUT.base,
    children: [
      {
				path: '/',
				component: TechnicalDiagnosticsLayout,
        children: [
          {
            path: '',
            component: settingsLayout,

						children: [
							{
								path: '',
								name: 'TechnicalDiagnosticsSettings',
								component: TechnicalDiagnosticsSettings,

								children: [
									{
										path: 'tests',
										name: 'tests',
										component: () => import(/* webpackChunkName: 'bids-section' */ '@/modules/TechnicalDiagnostics/views/pages/SystemTests.vue'),
									},
								],
							},
						],
          },
        ],
      },
    ],
  },
];
